import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { DescriptionField, Loadable } from "components/support";
import Typography from "material-ui-next/Typography";
import Divider from "material-ui-next/Divider";
import Chip from "material-ui-next/Chip";

const table = integrations => {
  return integrations.map((integration, index) => {
    const status = integration.enabled
      ? {
          label: "Habilitada",
          color: "#019863",
          backgroundColor: "#E1FAF1"
        }
      : {
          label: "Desabilitada",
          color: "#CC0000",
          backgroundColor: "#FCE8E8"
        };

    return (
      <Row key={index}>
        <Col xs={12}>
          <div
            style={{
              paddingTop: "8px",
              paddingBottom: "8px",
              fontSize: "21px",
              color: "#212539"
            }}
          >
            <strong style={{ fontSize: "0.8em", paddingLeft: "4px" }}>
              Status
            </strong>
            <Chip
              label={status.label}
              style={{
                backgroundColor: status.backgroundColor,
                color: status.color
              }}
            />
          </div>
          <DescriptionField label="Token" value={integration.token} />
          <DescriptionField
            label="Organização"
            value={integration.organization_name}
          />
          <DescriptionField label="Estoque" value={integration.stock_name} />
          <DescriptionField
            label="Canal de Venda"
            value={integration.sale_channel_name}
          />
        </Col>
      </Row>
    );
  });
};

class CompanyIntegrationsOmsView extends Component {
  render() {
    const { viewModel, className } = this.props;
    const { data, loading } = viewModel;

    return (
      <div className={`${className} grid-container`} style={{ padding: 20 }}>
        <Loadable loading={loading}>
          <Typography type="headline">Nexaas OMS</Typography>

          <Divider />

          {data.length !== 0 ? (
            table(data)
          ) : (
            <p style={{ marginTop: 20 }}>
              Não há integrações a serem mostradas.
            </p>
          )}
        </Loadable>
      </div>
    );
  }
}

export default CompanyIntegrationsOmsView;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/oms/view.jsx